var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: "100%",
  viewBox: "0 0 60 60",
  width: "100%",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "ytPfpControlsLargePlayButtonIconBg",
  d: "M30,0A30,30 0 1,0 60,30A30,30 0 0,0 30,0Z",
  fill: "#000",
  fillOpacity: 0.7
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21,41.65V18L43.7,29.85Z",
  fill: "#fff"
})));
export default SvgPlayButton;